import {
  DHL_DELIVERY_SERVICE,
  TNT_DELIVERY_SERVICE,
  NOVAPOSHTA_INTERNATIONAL_DELIVERY_SERVICE,
} from "../../staticData/staticVariables";

/**
 * Checks for what express delivery services are allowed to be created by the current user
 * (used to build props for ChooseExpressOrderPopup and similar popups)
 */
export const expressCreatePopupMixin = {
  methods: {
    checkCreateDHL() {
      if(this.loadUserAuthorizedData.user?.company_owner?.id) {
        if(this.isPolandByUserData(this.loadUserAuthorizedData.user?.owner_user_personal_contact?.country_group)) {
          return null
        } else {
          return '/create/dhl'
        }
      }

      if (this.checkUserFromSNGGroup(DHL_DELIVERY_SERVICE) &&
          this.checkDHLExpressUserFromGB(DHL_DELIVERY_SERVICE.id) &&
          (!this.isPoland && !this.isUserAlternativeContactPoland) &&
          this._.has(this.currentPermissions, this.PERMISSIONS.ORDER_EXPRESS_DHL)) {
        return '/create/dhl'
      }
      return null
    },

    checkCreateTNT() {
      if (this.checkUkrainianUserInTNT(TNT_DELIVERY_SERVICE.id) &&
          this._.has(this.currentPermissions, this.PERMISSIONS.ORDER_EXPRESS_TNT)) {
        return '/create/tnt'
      }
      return null
    },

    checkCreateFedex() {
      if (this._.has(this.currentPermissions, this.PERMISSIONS.ORDER_EXPRESS_FEDEX)) {
        return '/create/fedex'
      }
      return null
    },

    checkCreateDHLPL() {
      if(this.isISubUser && !this.isUserOwnerFromPoland(this.getCurrentUser)) {
        return null
      }

      if (this._.has(this.currentPermissions, this.PERMISSIONS.ORDER_EXPRESS_DHLPL) && (this.isPoland || this.isUserAlternativeContactPoland || this.isAdmin)) {
        return '/create/dhlpl'
      }
      return null
    },

    checkCreatePoshta() {
      /**
       * if NOVAPOSHTA GLOBAL and No From Ukraine -> null
       */
      // if(!this.isAdmin && !this.isUserUkraineOrAlternativeContactUkraine) {
      //   return null
      // }
      //
      // if (this._.has(this.currentPermissions, this.PERMISSIONS.ORDER_EXPRESS_NPG)) {
      //   return '/create/' + NOVAPOSHTA_GLOBAL_DELIVERY_SERVICE.name
      // }
      return null
    },

    checkCreateNPI() {
      /**
       * if NOVAPOSHTA GLOBAL and No From Ukraine -> null
       */
      if(!this.isAdmin && !this.isUserUkraineOrAlternativeContactUkraine) {
        return null
      }

      if (this._.has(this.currentPermissions, this.PERMISSIONS.ORDER_EXPRESS_NPI)) {
        return '/create/' + NOVAPOSHTA_INTERNATIONAL_DELIVERY_SERVICE.name
      }
      return null
    },

    checkCreateUPS() {
      // if (this._.has(this.currentPermissions, this.PERMISSIONS.ORDER_EXPRESS_UPS)) {
      //   return '/create/ups'
      // }
      return null
    },

    checkUserFromSNGGroup(item) {
      if (this.isAdmin) return true

      let user = this.$store.getters.getUserProfile,
          group = user.user_personal_contact?.country_group?.fromSNGGroup

      return !(group && (item.id === DHL_DELIVERY_SERVICE.id || !item.id))
    },
  }
}
